import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import {
  fetchConsolidationOrganisationInfo,
  fetchConsolidations
} from '../../organisations/src/core/api/consolidation/consolidation';
import { queryClient } from '../core/queryClient';

export type FetchConsolidationOrganisationInfoResult = Awaited<ReturnType<typeof fetchConsolidationOrganisationInfo>>;
export type FetchConsolidationsResult = Awaited<ReturnType<typeof fetchConsolidations>>;

type ConsolidationOrganisationInfoQueryOptions = Omit<
  QueryObserverOptions<FetchConsolidationOrganisationInfoResult>,
  'queryKey' | 'queryFn'
>;

type ConsolidationsQueryOptions = Omit<QueryObserverOptions<FetchConsolidationsResult>, 'queryKey' | 'queryFn'>;

export const consolidationsQueryKey = (workspaceId: string) => ['consolidations', workspaceId];

export const consolidationsQueryConfig = (workspaceId: string, options?: ConsolidationsQueryOptions) => ({
  queryKey: consolidationsQueryKey(workspaceId),
  queryFn: () => fetchConsolidations(workspaceId),
  ...options
});

export const consolidationsQuery = (
  workspaceId: string,
  options?: ConsolidationsQueryOptions
): QueryObserver<FetchConsolidationsResult> =>
  new QueryObserver<FetchConsolidationsResult>(queryClient, consolidationsQueryConfig(workspaceId, options));

export const consolidationOrganisationInfoQueryKey = (workspaceId: string) => [
  'consolidation-organisation-info',
  workspaceId
];

export const consolidationOrganisationInfoQueryConfig = (
  workspaceId: string,
  options?: ConsolidationOrganisationInfoQueryOptions
) => ({
  queryKey: consolidationOrganisationInfoQueryKey(workspaceId),
  queryFn: () => fetchConsolidationOrganisationInfo(workspaceId),
  ...options
});

export const consolidationOrganisationInfoQuery = (
  workspaceId: string,
  options?: ConsolidationOrganisationInfoQueryOptions
): QueryObserver<FetchConsolidationOrganisationInfoResult> =>
  new QueryObserver<FetchConsolidationOrganisationInfoResult>(
    queryClient,
    consolidationOrganisationInfoQueryConfig(workspaceId, options)
  );
